import { isSameDomain } from '../utils.js';

export default function () {
  const widgetName = 'hotButtons';
  const widgetOpts = hotButtonsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data) {
      const widgetCount = data.items.length;
      if (widgetCount == 0) {
        $(`#${widgetName}`).remove();
      } else {
        removeHref(data);
        $('<h2 class="hot-buttons-title">CHOOSE YOUR VIBE</h2>').prependTo('#hotButtons');
        isSameDomain(data, widgetName);
      }
    },
    buyNowButton: false,
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: ['all'],
    maxItemsVisible: 5,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false,
    textOverImage: true,
  });
}

// Removes href attribute if the button has no link
function removeHref(data) {
  $('#hotButtons .card-widget-item').each(function (x, item) {
    $(item).removeAttr('target');
    if (data.items[x]?.URL === null) {
      $(item).removeAttr('href');
    }
  });
}
